'use client';

import { useEffect } from 'react';

const RELOAD_FLAG = 'wellquip-chunk-reload';

function isChunkLoadFailure(value: unknown) {
  if (!value) return false;

  const message = typeof value === 'string'
    ? value
    : value instanceof Error
      ? value.message
      : typeof value === 'object' && 'message' in value
        ? String((value as { message?: unknown }).message ?? '')
        : '';

  return (
    message.includes('ChunkLoadError') ||
    message.includes('Loading chunk') ||
    message.includes('Failed to load chunk') ||
    message.includes('Loading CSS chunk') ||
    message.includes('Loading chunk 963 failed')
  );
}

export default function ChunkReloadGuard() {
  useEffect(() => {
    const triggerReload = () => {
      if (sessionStorage.getItem(RELOAD_FLAG) === '1') return;
      sessionStorage.setItem(RELOAD_FLAG, '1');
      window.location.reload();
    };

    const onError = (event: ErrorEvent) => {
      const target = event.error ?? event.message;
      if (isChunkLoadFailure(target)) {
        event.preventDefault();
        triggerReload();
      }
    };

    const onUnhandledRejection = (event: PromiseRejectionEvent) => {
      if (isChunkLoadFailure(event.reason)) {
        event.preventDefault();
        triggerReload();
      }
    };

    window.addEventListener('error', onError);
    window.addEventListener('unhandledrejection', onUnhandledRejection);

    return () => {
      window.removeEventListener('error', onError);
      window.removeEventListener('unhandledrejection', onUnhandledRejection);
    };
  }, []);

  return null;
}
